import { api } from './api';
import type { AvaliacoesMap } from 'types/etapa2';

const COLLECTION = 'rascunho_etapa2__c';
const COLLECTION_PATH = `/database/${COLLECTION}`;
const AGGREGATE_PATH = `/database/${COLLECTION}/aggregate`;

const rascunhoId = (avaliadorId: string, category: string) =>
  `rascunho_etapa2_${avaliadorId}_${category}`;

export const buscarRascunho = async (
  avaliadorId: string,
  category: string
): Promise<AvaliacoesMap | null> => {
  try {
    const pipeline = [
      { $match: { _id: rascunhoId(avaliadorId, category) } },
      { $limit: 1 },
    ];
    const { data } = await api.post(AGGREGATE_PATH, pipeline);
    const results = Array.isArray(data) ? data : [];
    if (results.length === 0) return null;
    return (results[0].notasRascunho as AvaliacoesMap) ?? null;
  } catch (err) {
    console.error('[rascunho-etapa2] Erro ao buscar rascunho:', err);
    return null;
  }
};

export const salvarRascunho = async (
  avaliadorId: string,
  category: string,
  avaliacoes: AvaliacoesMap
): Promise<void> => {
  try {
    await api.put(COLLECTION_PATH, {
      _id: rascunhoId(avaliadorId, category),
      avaliadorId,
      category,
      notasRascunho: avaliacoes,
      savedAt: Date.now(),
    });
  } catch (err) {
    console.error('[rascunho-etapa2] Erro ao salvar rascunho:', err);
  }
};

export const deletarRascunho = async (
  avaliadorId: string,
  category: string
): Promise<void> => {
  try {
    const id = rascunhoId(avaliadorId, category);
    await api.delete(`${COLLECTION_PATH}?q=_id:"${id}"`);
  } catch (err) {
    console.error('[rascunho-etapa2] Erro ao deletar rascunho:', err);
  }
};
